require('./plugins/loadcss');

import Vue from 'vue';

import store from "./store/kiosk";
window._ = require('lodash');

require('./plugins/v-mask');
import vuetify from './plugins/vuetify';
import App from "./components/App";

window.REZO = {
    init(elId){
        const advance = new Vue({
            render: h => h(App),
            store,
            vuetify,
        }).$mount(elId);
    }
}
